import { Project } from './types';
import { getAllProjects, saveProjects, setCurrentProjectId } from './storage';
import { generateProjectId } from './storage';

// Export a project to JSON file
export const exportProject = (projectId: string): void => {
  const projects = getAllProjects();
  const project = projects.find(p => p.id === projectId);

  if (!project) {
    console.error('Project not found for export');
    return;
  }

  const dataStr = JSON.stringify(project, null, 2);
  const dataUri =
    'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);

  const exportFileDefaultName = `${project.name.replace(/[^a-z0-9]/gi, '_').toLowerCase()}_${Date.now()}.json`;

  const linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', exportFileDefaultName);
  linkElement.click();
};

// Import a project from JSON file
export const importProject = (file: File): Promise<Project> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const content = e.target?.result as string;
        const importedProject = JSON.parse(content) as Project;

        // Validate the imported project structure
        if (
          !importedProject.id ||
          !importedProject.name ||
          !Array.isArray(importedProject.elements) ||
          !importedProject.viewport ||
          typeof importedProject.createdAt !== 'number' ||
          typeof importedProject.updatedAt !== 'number'
        ) {
          throw new Error('Invalid project file format');
        }

        // Generate new ID to avoid conflicts
        const newProject: Project = {
          ...importedProject,
          id: generateProjectId(),
          name: `${importedProject.name} (Imported)`,
          updatedAt: Date.now(),
        };

        // Add to projects list
        const projects = getAllProjects();
        projects.push(newProject);
        saveProjects(projects);
        setCurrentProjectId(newProject.id);

        resolve(newProject);
      } catch (error) {
        reject(
          new Error('Failed to parse project file: ' + (error as Error).message)
        );
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};
